import type React from "react";
import type { InputHTMLAttributes } from "react";
import { tw } from "../../../styling";
import { SvgIcon } from "../../svg-icon";

type Props = InputHTMLAttributes<HTMLInputElement> & {
	name: string;
	value: string;
};

export const RadioButton: React.FC<Props> = ({ checked, disabled, ...rest }) => (
	<span className={tw("flex w-5 self-center", disabled && "cursor-not-allowed")}>
		<SvgIcon
			imageSrc={checked ? "RADIO_CHECKED" : "RADIO_UNCHECKED"}
			className={disabled ? "text-interactive-disabled" : "text-interactive-primary"}
			height={20}
		/>
		<input className="sr-only" type="radio" checked={checked} disabled={disabled} {...rest} />
	</span>
);
